import CustomModal from "../CustomModal";

const PlanSuccessModal = ({ isOpen, onClose, title, message }) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Success Modal"
      className="edit-success-modal"
    >
      <img
        src={`${process.env.PUBLIC_URL}/images/thumbs-up.png`}
        alt="Success icon"
      />
      <h2 style={{ textAlign: "center" }}>{title}</h2>
      {message && <p style={{ textAlign: "center" }}>{message}</p>}
      <button onClick={onClose}>
        {title === "Plan deleted" ? "Cancel" : "Close"}
      </button>
    </CustomModal>
  );
};

export default PlanSuccessModal;
